import { AxiosResponse } from 'axios';
import {
  SET_PAYROLLS,
  SET_PAYROLL,
  SET_EMPLOYEES_WITHOUT_SALARY,
  SET_PAYROLL_STATS_CHART,
  SET_ERRORMSG,
  SET_EMPLOYEES_WITH_SALARY,
  SET_PAYROLL_COMPENSATION,
  SET_PAYROLL_ANALYTICS,
  SET_PAYROLL_EMPLOYEE_ANALYTICS,
  SET_PAYROLL_EXPORT,
} from '@/store/mutation_types';
import {
  APPROVE_PAYROLL,
  CLEAR_PAYROLL_ISLOADING,
  DELETE_PAYROLL,
  EDIT_PAYROLL,
  EXPORT_PAYROLL_ETAX,
  EXPORT_EMPLOYEE_PAYROLL_SLIP_PDF,
  EXPORT_PAYROLL_BANK_REPORT_PDF,
  EXPORT_PAYROLL_CSV,
  EXPORT_PAYROLL_REPORT,
  GENERATE_PAYROLL,
  GET_EMPLOYEES_WITH_SALARY,
  GET_EMPLOYEES_WITHOUT_SALARY,
  GET_PAYROLL_ANALYTICS,
  GET_PAYROLL_DETAILS,
  GET_PAYROLL_EMPLOYEE_ANALYTICS,
  GET_PAYROLL_STATS_CHART,
  GET_PAYROLL_COMPENSATION,
  REGISTER_PAYROLL,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Payroll from '@/services/payroll';
import { Module } from 'vuex';
import { InitiatePayrollBody } from '@/dtos/payroll.dto';
import PayrollPeriod from '@/services/payroll_period';
import { GetPayrollPeriod } from '@/dtos/payroll_period.dto';

const payroll: Module<any, {}> = {
  state: {
    payroll: {
      data: null,
      isLoading: false,
    },
    payrolls: {
      data: null,
      isLoading: false,
    },
    payrollStatsChart: {
      data: null,
      isLoading: false,
    },
    employeesWithoutSalary: {
      data: null,
      isLoading: false,
    },
    employeesWithSalary: {
      data: null,
      isLoading: false,
    },
    payrollCompensation: {
      data: null,
      isLoading: false,
    },
    payrollAnalytics: {
      data: null,
      metaData: null,
      isLoading: false,
    },
    payrollEmployeeAnalytics: {
      data: null,
      isLoading: false,
    },
    payrollExport: {
      isLoading: false,
    },
  },
  getters: {
    payroll: (state: { payroll: any }) => state.payroll,
    payrolls: (state: { payrolls: any }) => state.payrolls,
    payrollStatsChart: (state: { payrollStatsChart: any }) => state.payrollStatsChart,
    employeesWithoutSalary: (state: { employeesWithoutSalary: any }) => state.employeesWithoutSalary,
    employeesWithSalary: (state: { employeesWithSalary: any }) => state.employeesWithSalary,
    payrollCompensation: (state: { payrollCompensation: any }) => state.payrollCompensation,
    payrollAnalytics: (state: { payrollAnalytics: any }) => state.payrollAnalytics,
    payrollEmployeeAnalytics: (state: { payrollEmployeeAnalytics: any }) => state.payrollEmployeeAnalytics,
    payrollExport: (state: { payrollExport: any }) => state.payrollExport,
  },
  mutations: {
    [SET_PAYROLL]: (
      state: { payroll: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.payroll.data = payload.data) : null,
        (state.payroll.isLoading = payload.isLoading);
    },
    [SET_PAYROLLS]: (
      state: { payrolls: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.payrolls.data = payload.data) : null,
        (state.payrolls.isLoading = payload.isLoading);
    },
    [SET_PAYROLL_STATS_CHART]: (
      state: { payrollStatsChart: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.payrollStatsChart.data = payload.data) : null,
        (state.payrollStatsChart.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEES_WITHOUT_SALARY]: (
      state: { employeesWithoutSalary: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeesWithoutSalary.data = payload.data) : null,
        (state.employeesWithoutSalary.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEES_WITH_SALARY]: (
      state: { employeesWithSalary: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeesWithSalary.data = payload.data) : null,
        (state.employeesWithSalary.isLoading = payload.isLoading);
    },
    [SET_PAYROLL_COMPENSATION]: (
      state: { payrollCompensation: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.payrollCompensation.data = payload.data) : null,
        (state.payrollCompensation.isLoading = payload.isLoading);
    },
    [SET_PAYROLL_ANALYTICS]: (
      state: { payrollAnalytics: StateObject },
      payload: { data?: any; metaData?: any; isLoading: boolean }
    ) => {
      if (payload.data !== undefined) state.payrollAnalytics.data = payload.data;
      if (payload.metaData !== undefined) state.payrollAnalytics.metaData = payload.metaData;
      state.payrollAnalytics.isLoading = payload.isLoading;
    },
    [SET_PAYROLL_EMPLOYEE_ANALYTICS]: (
      state: { payrollEmployeeAnalytics: StateObject },
      payload: { data?: any; isLoading: boolean }
    ) => {
      if (payload.data !== undefined) state.payrollEmployeeAnalytics.data = payload.data;
      state.payrollEmployeeAnalytics.isLoading = payload.isLoading;
    },
    [SET_PAYROLL_EXPORT]: (state: { payrollExport: { isLoading: boolean } }, payload: { isLoading: boolean }) => {
      state.payrollExport.isLoading = payload.isLoading;
    },
  },
  actions: {
    [GET_PAYROLL_ANALYTICS]: async ({ commit }: any, payload: Record<string, any>) => {
      commit(SET_PAYROLL_ANALYTICS, { isLoading: true });
      const result: AxiosResponse = await Payroll.getPayrollAnalytics(payload);
      if (result) {
        if (result.data.status) {
          commit(SET_PAYROLL_ANALYTICS, { data: result.data.data, metaData: result.data.metaData, isLoading: false });
          return true;
        }
        commit(SET_PAYROLL_ANALYTICS, { isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      }
      commit(SET_PAYROLL_ANALYTICS, { isLoading: false });
      return false;
    },
    [GET_PAYROLL_EMPLOYEE_ANALYTICS]: async ({ commit }: any, payload: Record<string, any>) => {
      commit(SET_PAYROLL_EMPLOYEE_ANALYTICS, { data: null, isLoading: true });
      const result: AxiosResponse = await Payroll.getPayrollEmployeeAnalytics(payload);
      if (result) {
        if (result.data.status) {
          commit(SET_PAYROLL_EMPLOYEE_ANALYTICS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PAYROLL_EMPLOYEE_ANALYTICS, { isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      }
      commit(SET_PAYROLL_EMPLOYEE_ANALYTICS, { isLoading: false });
      return false;
    },
    [EXPORT_PAYROLL_REPORT]: async ({ commit }: any, payload: Record<string, any>) => {
      commit(SET_PAYROLL_EXPORT, { isLoading: true });
      const result: AxiosResponse = await Payroll.exportPayrollReport(payload);
      commit(SET_PAYROLL_EXPORT, { isLoading: false });
      return result || false;
    },
    [REGISTER_PAYROLL]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL, { data: null, isLoading: true });

      const result: AxiosResponse = await Payroll.registerPayroll(
        payload as InitiatePayrollBody
      );

      if (result) {
        if (result.data.status) {
          commit(SET_PAYROLL, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_PAYROLL, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL, { isLoading: false });
        return false;
      }
    },
    [GENERATE_PAYROLL]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL, { data: null, isLoading: true });

      const result: AxiosResponse = await Payroll.generatePayroll(
        payload
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PAYROLL, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PAYROLL, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL, { isLoading: false });
        return false;
      }
    },
    [GET_PAYROLL_DETAILS]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL, { data: null, isLoading: true });

      const result: AxiosResponse = await Payroll.getPayrollDetails(
        payload as GetPayrollPeriod
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data 01', result.data.data);
          commit(SET_PAYROLL, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_PAYROLL, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL, { isLoading: false });
        return false;
      }
    },
    [EXPORT_PAYROLL_CSV]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL, { isLoading: true });

      const result: AxiosResponse = await Payroll.exportPayrollCSV(
        payload as GetPayrollPeriod
      );

      if (result) {
        commit(SET_PAYROLL, { isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return result;
      } else {
        commit(SET_PAYROLL, { isLoading: false });
        return false;
      }
    },
    [EXPORT_PAYROLL_BANK_REPORT_PDF]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL, { isLoading: true });

      const result: AxiosResponse = await Payroll.exportPayrollBankReportPDF(
        payload as GetPayrollPeriod
      );

      if (result) {
        commit(SET_PAYROLL, { isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return result;
      } else {
        commit(SET_PAYROLL, { isLoading: false });
        return false;
      }
    },
    [EXPORT_EMPLOYEE_PAYROLL_SLIP_PDF]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL, { isLoading: true });

      const result: AxiosResponse = await Payroll.exportEmployeePayrollSlipPDF(
        payload as GetPayrollPeriod
      );

      if (result) {
        commit(SET_PAYROLL, { isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return result;
      } else {
        commit(SET_PAYROLL, { isLoading: false });
        return false;
      }
    },
    [EXPORT_PAYROLL_ETAX]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL, { isLoading: true });

      const result: AxiosResponse = await Payroll.exportEmployeePayrollETax(
        payload as GetPayrollPeriod
      );

      if (result) {
        commit(SET_PAYROLL, { isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return result;
      } else {
        commit(SET_PAYROLL, { isLoading: false });
        return false;
      }
    },
    [GET_PAYROLL_STATS_CHART]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL_STATS_CHART, { data: null, isLoading: true });

      const result: AxiosResponse = await Payroll.getPayrollStatsChart(
        payload as GetPayrollPeriod
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PAYROLL_STATS_CHART, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_PAYROLL_STATS_CHART, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL_STATS_CHART, { data: null, isLoading: false });
        return false;
      }
    },
    [APPROVE_PAYROLL]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL, { isLoading: true });

      const result: AxiosResponse = await Payroll.approvePayroll(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PAYROLL, { isLoading: false });
          return true;
        }
        commit(SET_PAYROLL, { isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEES_WITHOUT_SALARY]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEES_WITHOUT_SALARY, { data: null, isLoading: true });

      const result: AxiosResponse = await Payroll.getEmployeesWithoutSalary(
        payload as GetPayrollPeriod
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEES_WITHOUT_SALARY, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_EMPLOYEES_WITHOUT_SALARY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEES_WITHOUT_SALARY, { data: null, isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEES_WITH_SALARY]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEES_WITH_SALARY, { data: null, isLoading: true });

      const result: AxiosResponse = await Payroll.getEmployeesWithSalary(
        payload as GetPayrollPeriod
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEES_WITH_SALARY, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_EMPLOYEES_WITH_SALARY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEES_WITH_SALARY, { data: null, isLoading: false });
        return false;
      }
    },
    [GET_PAYROLL_COMPENSATION]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL_COMPENSATION, { isLoading: true });

      const result: AxiosResponse = await Payroll.getCompensationOverview(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_PAYROLL_COMPENSATION, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_PAYROLL_COMPENSATION, { isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL_COMPENSATION, { isLoading: false });
        return false;
      }
    },
    [DELETE_PAYROLL]: async ({ commit }: any, payload: string) => {
      commit(SET_PAYROLL, { data: null, isLoading: true });

      const result: AxiosResponse = await Payroll.deletePayroll(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PAYROLL, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PAYROLL, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL, { isLoading: false });
        return false;
      }
    },
    [CLEAR_PAYROLL_ISLOADING]: ({ commit }) => {
      commit(SET_PAYROLL, { isLoading: false });
      commit(SET_PAYROLLS, { isLoading: false });
      commit(SET_PAYROLL_STATS_CHART, { isLoading: false });
    },
  },
};

export default payroll;
